'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = filterMountOrUnmount;


var findChild = function findChild(children, child) {
  return children.find(function (r) {
    return r && r.key === child.key;
  });
};


var childDefaultState = {
  willUnmount: false,
  willMount: false
};

function filterMountOrUnmount(childrenStoreInState, children) {
  var result = {
    mappedChildren: [],
    childrenWillUnmount: false,
    childrenWillMount: false
  };

  // any children got removed
  result.mappedChildren = childrenStoreInState.map(function (child) {
    if (!child || !Object.prototype.hasOwnProperty.call(child, 'key')) {
      return null;
    }

    if (!findChild(children, child)) result.childrenWillUnmount = true;

    return _extends({}, child, findChild(children, child) ? _extends({}, childDefaultState) : { willUnmount: true });
  });

  // append missing child
  children.forEach(function (child, index) {
    if (child && Object.prototype.hasOwnProperty.call(child, 'key') && !findChild(result.mappedChildren, child)) {
      result.childrenWillMount = true;
      result.mappedChildren.splice(index === 0 ? 0 : index + 1, 0, _extends({}, child, {
        willMount: true
      }));
    }
  });

  return result;
}